// frontend/src/pages/AreasPage.js

import React, { useState, useEffect, useCallback } from 'react';
import { Box, Typography, TextField, Button, Paper, List, ListItem, ListItemText, IconButton, CircularProgress } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import api from '../services/api';
import { useNotification } from '../context/NotificationContext';

const AreasPage = () => {
  const { showSuccess, showError } = useNotification();
  const [areas, setAreas] = useState([]);
  const [newAreaName, setNewAreaName] = useState('');
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const fetchAreas = useCallback(async () => {
    try {
      setLoading(true);
      const response = await api.get('/areas/');
      setAreas(response.data);
    } catch (error) {
      console.error("Falha ao buscar áreas", error);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchAreas();
  }, [fetchAreas]);

  const handleCreate = async (event) => {
    event.preventDefault();
    if (!newAreaName.trim()) return;
    setIsSubmitting(true);
    try {
      await api.post('/areas/', { nome: newAreaName });
      setNewAreaName('');
      fetchAreas();
      showSuccess('Área criada com sucesso!');
    } catch (error) {
      console.error("Falha ao criar área", error.response?.data || error);
      showError('Erro ao criar área.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Tem certeza que deseja excluir esta área?')) {
      try {
        await api.delete(`/areas/${id}/`);
        fetchAreas();
        showSuccess('Área excluída com sucesso!');
      } catch (error) {
        console.error("Falha ao excluir área", error);
        showError('Erro ao excluir área.');
      }
    }
  };
  
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Gerenciamento de Áreas</Typography>
      
      <Paper component="form" onSubmit={handleCreate} elevation={2} sx={{ p: 2, mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <TextField
          label="Nome da Nova Área"
          value={newAreaName}
          onChange={(e) => setNewAreaName(e.target.value)}
          variant="outlined"
          size="small"
          sx={{ flexGrow: 1 }}
        />
        <Button type="submit" variant="contained" disabled={isSubmitting}>
          {isSubmitting ? <CircularProgress size={24} /> : 'Criar Área'}
        </Button>
      </Paper>

      <Typography variant="h6">Áreas Existentes</Typography>
      {loading ? <CircularProgress /> : (
        <List>
          {areas.map((area) => (
            <ListItem 
              key={area.id}
              divider
              secondaryAction={
                <IconButton edge="end" aria-label="delete" onClick={() => handleDelete(area.id)}>
                  <DeleteIcon color="error" />
                </IconButton>
              }
            >
              <ListItemText primary={area.nome} />
            </ListItem>
          ))}
        </List>
      )}
    </Box>
  );
};

export default AreasPage;